import clsx, { type ClassValue } from 'clsx'

/** Kortnamn för villkorliga klassnamn. */
export function cn(...values: ClassValue[]): string {
  return clsx(values)
}
